import type { ChangeEvent } from 'react';
import {
  FormField,
  FormInputGroup,
  FormLabel,
  StandardForm,
  Dropdown,
  DropdownOption,
  GridContainer,
  Row,
  Column,
} from '@vp/swan';

import { useDebugModeContext } from '../../contexts/DebugModeContext';

const modBossLogLevels = ['Trace', 'Debug', 'Info', 'Warn', 'Error', 'Silent'];

export const ModBossLogDropdown = () => {
  const { modBossLogLevel, setModBossLogLevel } = useDebugModeContext();

  const onOptionSelect = (event: ChangeEvent<HTMLSelectElement>) => {
    setModBossLogLevel(event.target.value);
  };

  return (
    <StandardForm variant="horizontal">
      <GridContainer>
        <Row component={FormField}>
          <Column span={6}>
            <FormLabel>ModBoss Log Level:</FormLabel>
          </Column>
          <Column span={6}>
            <FormInputGroup>
              <Dropdown
                compactMode
                onChange={onOptionSelect}
                value={modBossLogLevel}
                mx={3}
              >
                {modBossLogLevels.map((logLevel: string) => (
                  <DropdownOption value={logLevel} key={logLevel}>
                    {logLevel}
                  </DropdownOption>
                ))}
              </Dropdown>
            </FormInputGroup>
          </Column>
        </Row>
      </GridContainer>
    </StandardForm>
  );
};
